import React from "react";
import "./../utils/Style/common.scss";

const HeaderComponent = (props) => {
    return (
      <div className="header_comp">
        {props.title}
      </div>
    );
  }

export default HeaderComponent;
